import { frontendOptions } from "../../../../../lib/systemData";
import CardGrey from "../../../../common/CardGrey";
import DefaultUpdater from "../../../../common/DefaultUpdater";

export default function PoliceReportBox({classes, label, reportValue, eCMValue, caseData ,eCMItem, primaryLiability, primaryMedPay, isProcessed}) {

    const disabledExtra = isProcessed ? { isDisabled: true, isDisable: true, isNotModifiable: true } : {}


    let merge_before_update_at_fault = {
        put_in: 'array',
        items: [
            {
                value_flag: 'in_all_cases',
                fields_to_modify: [
                    {
                        field: 'ins_owner',
                        value: null
                    },
                ]
            }
        ],
    
    }
    return <div className={classes.group_row}>
        <div className={classes.label}>
            <span>{label}</span>
        </div>
        <div className={classes.value}>
            <div className={`${classes.input}`}>{reportValue}</div>
        </div>
        <div className={classes.status}>            
            
        </div>
        <div className={classes.value}>
            {eCMValue && <>
            
                {eCMValue == 'comercial' && <>
                    {primaryMedPay && <div className={classes.checkbox_row}>
                        <DefaultUpdater type={'checkbox'} value={primaryMedPay?.commercial_policy} name={'commercial_policy'} label={'Auto Insurance Comercial Policy'} identifier={{type: 'case_mp_pip_um', field: 'commercial_policy', type_id: primaryMedPay.id, folder: 'mp_pip_um'}} extraOptions={{direction: 'reverse', ...disabledExtra}}/>
                    
                    </div>}
                    {primaryLiability && <div className={classes.checkbox_row}>
                        <DefaultUpdater type={'checkbox'} value={primaryLiability?.commercial_policy} name={'commercial_policy'} label={'Liability Comercial Policy'} identifier={{type: 'case_liability', field: 'commercial_policy', type_id: primaryLiability.id, folder: 'liabilities'}} extraOptions={{direction: 'reverse', ...disabledExtra}}/>                
                    </div>}
                </>}

                {eCMValue == 'medpay_ins_owner' && <>
                
                    {primaryMedPay && <>
                        <CardGrey >
                            <DefaultUpdater type={'radio'} value={primaryMedPay.ins_owner} options={frontendOptions()?.medpayins_owner} name={'ins_owner'} identifier={{type: 'case_mp_pip_um', field: 'ins_owner', type_id: primaryMedPay.id, folder: 'mp_pip_um'}} extraOptions={{normalSize: true, ...disabledExtra}} />
                        </CardGrey>  
                        {!primaryMedPay.self && <>
                            {primaryMedPay.ins_owner== 1 && <CardGrey>
                                <DefaultUpdater type={'checkbox'} value={primaryMedPay.driver_excluded} name={'driver_excluded'} label={'Excluded Driver'} identifier={{type: 'case_mp_pip_um', field: 'driver_excluded', type_id: primaryMedPay.id, folder: 'mp_pip_um'}} extraOptions={{direction: 'reverse', trueFlagDanger: true, ...disabledExtra}}/>
                            </CardGrey>}
                        </>} 
                    </>}
                    {!primaryMedPay && <div className={`${classes.input} ${classes.no_insurance}`} title="No Insurance Added"><i className="ti ti-ban"></i></div>}
                </>}

                {eCMValue == 'medpay_ins_name' && <>
                
                    {primaryMedPay && <>
                        <div className={`${classes.input} `} >{primaryMedPay.insurance_carrier?.name}</div>
                    </>}
                    {!primaryMedPay && <div className={`${classes.input} ${classes.no_insurance}`} title="No Insurance Added"><i className="ti ti-ban"></i></div>}
                </>}

                {eCMValue == 'liability_ins_name' && <>
                
                    {primaryLiability && <>
                        <div className={`${classes.input} `} >{primaryLiability.insurance_carrier?.name}</div>
                    </>}
                    {!primaryLiability && <div className={`${classes.input} ${classes.no_insurance}`} title="No Insurance Added"><i className="ti ti-ban"></i></div>}
                </>}

                {eCMValue == 'liability_at_fault' && <>
                    {primaryLiability && <>
                        <div className="flex-container flex-container-wrap">
                            <CardGrey>
                                <DefaultUpdater type={'radio'} value={primaryLiability.at_fault} options={frontendOptions()?.AT_Fault_Radio} name={'at_fault'} identifier={{type: 'case_liability', field: 'at_fault', type_id: primaryLiability.id, folder: 'liabilities'}} extraOptions={{normalSize: true, ...disabledExtra}} merge_before_update={merge_before_update_at_fault}/>
                            </CardGrey>
                            {(primaryLiability.at_fault == 2) ? <CardGrey>
                                <div style={{flex: 2}}>                                            
                                    <DefaultUpdater type={'radio'} value={primaryLiability.ins_owner} options={frontendOptions()?.liabilityOwnerRadio} name={'ins_owner'} identifier={{type: 'case_liability', field: 'ins_owner', type_id: primaryLiability.id, folder: 'liabilities'}} extraOptions={{normalSize: true, ...disabledExtra}}/>                                           
                                </div>
                            </CardGrey> : ''}
                        </div>
                    </>}
                    {!primaryLiability && <div className={`${classes.input} ${classes.no_insurance}`} title="No Insurance Added"><i className="ti ti-ban"></i></div>}
                </>}


                {eCMValue == 'liability_hit_and_run' && <>
                    {primaryLiability && <>
                        <DefaultUpdater type={'checkbox'} value={primaryLiability.hit_run} name={'hit_run'} label={'Hit And Run'} identifier={{type: 'case_liability', field: 'hit_run', type_id: primaryLiability.id, folder: 'liabilities'}} extraOptions={{direction: 'reverse', ...disabledExtra}}/>
                    </>}
                    {!primaryLiability && <div className={`${classes.input} ${classes.no_insurance}`} title="No Insurance Added"><i className="ti ti-ban"></i></div>}
                </>}
                
            
            </>}

        </div>
    </div>
}